// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35jOh","left":"styles_left__1ZoWj"};